export default "__VITE_ASSET__b10da407__"